import { InfoIcon } from "@phosphor-icons/react";

import { Popover, PopoverContent, PopoverTrigger } from "ui2";

export const MetricInfo = ({ text, label }: { text: string; label: string }): React.JSX.Element => (
  <Popover>
    <PopoverTrigger
      aria-label={label}
      className="tw tw:inline-flex tw:cursor-pointer tw:appearance-none tw:border-0 tw:bg-transparent tw:p-0 tw:text-midnight/40 tw:hover:text-midnight"
    >
      <InfoIcon className="tw:size-3.5" />
    </PopoverTrigger>
    <PopoverContent align="start" className="tw:text-xs tw:leading-relaxed tw:text-midnight">
      {text}
    </PopoverContent>
  </Popover>
);
